import { render, staticRenderFns } from "./RaTab.vue?vue&type=template&id=663e3984&"
import script from "./RaTab.vue?vue&type=script&lang=js&"
export * from "./RaTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports